module.exports = __webpack_public_path__ + "img/5.9bf0c5fa.png";